export const FLEX_CENTER_CENTER = {
    display: "flex",
    alignItems: 'center',
    justifyContent: 'center'
};